import { type UseMutationOptions, useMutation } from '@tanstack/vue-query'
import type { AxiosResponse } from 'axios'
import { axiosInstance } from '@/modules/Core/plugins/axios'
import type { RejectSwapPayload } from '@/modules/Messages/types/api/payload/swap'
import type { RejectSwapSuccessResponse } from '@/modules/Messages/types/api/response/swap'

const ENDPOINT = '/Swap/Reject'

export function rejectSwap(payload: RejectSwapPayload) {
  return axiosInstance.post<RejectSwapSuccessResponse>(
    ENDPOINT,
    {
      id: payload.id.value,
    },
    {
      baseURL: import.meta.env.VITE_API_OFFER_BASE_URL,
    }
  )
}

export function useRejectSwapMutation(
  options?: UseMutationOptions<
    AxiosResponse<RejectSwapSuccessResponse>,
    AxiosCustomError,
    RejectSwapPayload,
    any
  >
) {
  return useMutation({
    mutationFn: (payload: RejectSwapPayload) => rejectSwap(payload),
    ...options,
  })
}
